// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"ff2ef58c","460":"f8154cb0","514":"7bb5f162","674":"523b2926","917":"9999000d"}[chunkId] + ".chunk.css";
};